import React, { useState, useEffect } from 'react';

const UpdateNotification = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(registration => {
          // Check for updates periodically
          const updateInterval = setInterval(() => {
            registration.update();
          }, 30000); // Check every 30 seconds

          // Listen for new service worker waiting
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available!
                setShowUpdate(true);
              }
            });
          });

          // Cleanup interval on unmount
          return () => clearInterval(updateInterval);
        })
        .catch(error => {
          console.log('Service worker registration failed:', error);
        });
    }
  }, []);

  const handleUpdate = () => {
    setShowUpdate(false);
    window.location.reload();
  };

  const handleLater = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#2196F3',
      color: 'white',
      padding: '12px',
      textAlign: 'center',
      zIndex: 9999,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      fontSize: '14px',
      fontWeight: '500'
    }}>
      <span>🔄 New version available! Update now for the latest features and improvements.</span>
      <button 
        onClick={handleUpdate}
        style={{
          marginLeft: '15px',
          padding: '6px 12px',
          backgroundColor: 'white',
          color: '#2196F3',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '600'
        }}
      >
        Update Now
      </button>
      <button 
        onClick={handleLater}
        style={{
          marginLeft: '8px',
          padding: '6px 12px',
          backgroundColor: 'transparent',
          color: 'white',
          border: '1px solid white',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '13px'
        }}
      >
        Later
      </button>
    </div>
  );
};

export default UpdateNotification; 